import React, { Component } from 'react';
import { Route, Redirect, IndexRoute } from 'react-router'

import CoreLayout from 'components/layouts/CoreLayout'
import Auth from 'components/layouts/Auth'
import Error404 from 'components/Errors/Error404'

import Home from './projects'
import ProjectTemplates from './templates'
import ProjectsPage from './projects'
import NewProject from './NewProjectForm'
import Properties from './properties'
import TaskPage from './tasks/'
import TenantPage from './tenants/'
import Portfolios from './portfolios/'
import Tenant from './tenants'
import Owner from './owners'
import Manager from './managers'
import LeasePage from './leases'
import Repairmen from './repairmen'
import RepairmanForm from './repairmanForm'
import ListLayout from 'components/layouts/ListLayout'
import Search from './search'
import ProjectForm from './projectForm'
import ApplicationForm from './applicationForm'
import TaskForm from './taskForm'
import TenantForm from './tenantForm'
import ProjectTemplateForm from './templateForm'
import PropertiesPage from './properties'
import PropertyForm from './propertyForm'
import OwnerForm from './ownerForm'
import ManagerForm from './managerForm'
import LeaseForm from './leaseForm'
import AgentForm from './agentForm'
import Agents from './agents'
import TransactionsPage from './transactions'
import TransactionForm from './transactionForm'
import VendorForm from './vendorForm'
import ListingForm from './listingForm'
import TermForm from './termForm'
import QuoteForm from './quoteForm'
import Dashboard from './dashboard'

export default config => (
	<Route component={CoreLayout}>
		<Redirect from="/" to="/manager" />
		<Route
			path="/manager"
			component={routeProps => (
				<Auth {...routeProps} {...config} />
			)}
		>
			<IndexRoute component={Dashboard} />
	        <Route component={Dashboard} path="/manager/home"/>
	        <Route component={ProjectForm} path="/manager/project/:id"/>
	  		<Route component={TaskForm} path="/manager/task/:id" />
	  		<Route component={TenantForm} path="/manager/tenant/:id" />
	  		<Route component={PropertyForm} path="/manager/property/:id" />
	        <Route component={TransactionForm} path="/manager/transaction/:id" />
	        <Route component={LeaseForm} path="/manager/lease/:id" />
	  		<Route component={TenantForm} path="/manager/tenant/:id" />
	  		<Route component={OwnerForm} path="/manager/owner/:id" />
	  		<Route component={ManagerForm} path="/manager/manager/:id" />
	  		<Route component={ProjectTemplateForm} path="/manager/template/:id" />
	  		<Route component={RepairmanForm} path="/manager/repairman/:id" />
	  		<Route component={AgentForm} path="/manager/agent/:id" />
	  		<Route component={VendorForm} path="/manager/vendor/:id" />
			<Route component={ApplicationForm} path="/manager/application/:id" />
	  		<Route component={ListingForm} path="/manager/listing/:id" />
	  		<Route component={TermForm} path="/manager/term/:id" />
			<Route component={QuoteForm} path="/manager/quote/:id" />
	        <Route component={ProjectsPage} path="/manager/projects" />
			<Route component={ProjectsPage} path="/manager/projects/:id" />
	        <Route component={TransactionsPage} path="/manager/transactions" />
			<Route component={TransactionsPage} path="/manager/transactions/:id" />
	        <Route component={TaskPage} path="/manager/tasks" />
			<Route component={TaskPage} path="/manager/tasks/:id" />
	        <Route component={TenantPage} path="/manager/tenants" />
	        <Route component={LeasePage} path="/manager/leases" />
			<Route component={TenantPage} path="/manager/tenants/:id" />
			<Route component={LeasePage} path="/manager/leases/:id" />
			<Route component={PropertiesPage} path="/manager/properties" />
			<Route component={PropertiesPage} path="/manager/properties/:id" />
			<Route component={Portfolios} path="/manager/portfolios" />
			<Route component={Search} path="/manager/search" />
			<Route component={ListLayout}>
				<Route
					component={ProjectTemplates}
					path="/manager/templates"
					categoryText="Tempaltes"
					type="template"
					addText="New template"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , todos: []
							  , type: "template"
						})
						opts.go(`/manager/templates/${id}`)
					}}
				/>
				<Route
					component={ProjectTemplates}
					path="/manager/templates/:id"
					categoryText="Tempaltes"
					type="template"
					renderEl={(opts) => (
						<ProjectTemplateForm
							rightPanel = {opts.rightPanel}
							style = {opts.style}
							id = {opts.id}
							history = {opts.history}
							refTask = {opts.refTask}
							refRepMan = {opts.refRepMan}
						/>
					)}
					addText="New template"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , todos: []
							  , type: "template"
						})
						opts.go(`/manager/templates/${id}`)
					}}
				/>
				<Route
					component={Owner}
					path="/manager/owners"
					categoryText="Owners"
					type="owner"
					addText="New owner"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , firstName: ""
							  , companyName: ""
							  , phoneNumber: ""
							  , ownerType: "person"
							  , cellNumber: ""
							  , email: ""
							  , address: ""
							  , checkAddress: ""
							  , iin: ""
							  , note: ''
							  , type: "owner"
							  , properties: []
							  , comments: []
						})
						opts.go(`/manager/owners/${id}`)
					}}
				/>
				<Route
					component={Owner}
					path="/manager/owners/:id"
					categoryText="Owners"
					type="owner"
					renderEl={(opts) => (
						<OwnerForm
							rightPanel = {opts.rightPanel}
							style = {opts.style}
							id = {opts.id}
							history = {opts.history}
							refTask = {opts.refTask}
							refRepMan = {opts.refRepMan}
						/>
					)}
					addText="New owner"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , firstName: ""
							  , companyName: ""
							  , phoneNumber: ""
							  , ownerType: "person"
							  , cellNumber: ""
							  , email: ""
							  , address: ""
							  , checkAddress: ""
							  , iin: ""
							  , note: ''
							  , type: "owner"
							  , properties: []
							  , comments: []
						})
						opts.go(`/manager/owners/${id}`)
					}}
				/>
				<Route
					component={Manager}
					path="/manager/managers"
					categoryText="Managers"
					type="manager"
				/>
				<Route
					component={Manager}
					path="/manager/managers/:id"
					categoryText="Managers"
					type="manager"
					renderEl={(opts) => (
						<ManagerForm
							rightPanel = {opts.rightPanel}
							style = {opts.style}
							id = {opts.id}
							history = {opts.history}
							refTask = {opts.refTask}
							refRepMan = {opts.refRepMan}
						/>
					)}
				/>
				<Route
					component={Repairmen}
					path="/manager/repairmen"
					categoryText="Repairmen"
					type="repairman"
					addText="New repairman"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , firstName: ""
							  , lastName: ""
							  , phoneNumber: ""
							  , cellNumber: ""
							  , email: ""
							  , address: ""
							  , categories: []
							  , note: ''
							  , type: "repairman"
							  , rating: ''
							  , tasks: []
						})
						opts.go(`/manager/repairmen/${id}`)
					}}
				/>
				<Route
					component={Repairmen}
					path="/manager/repairmen/:id"
					categoryText="Repairmen"
					type="repairman"
					renderEl={(opts) => (
						<RepairmanForm
							rightPanel = {opts.rightPanel}
							style = {opts.style}
							id = {opts.id}
							history = {opts.history}
							refTask = {opts.refTask}
							refRepMan = {opts.refRepMan}
						/>
					)}
					addText="New repairman"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , firstName: ""
							  , lastName: ""
							  , phoneNumber: ""
							  , cellNumber: ""
							  , email: ""
							  , address: ""
							  , categories: []
							  , note: ''
							  , type: "repairman"
							  , rating: ''
							  , tasks: []
						})
						opts.go(`/manager/repairmen/${id}`)
					}}
				/>
				<Route
					component={Agents}
					path="/manager/agents"
					addText="New agent"
					categoryText="Agents"
					type="agent"
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , firstName: ""
							  , lastName: ""
							  , phoneNumber: ""
							  , cellNumber: ""
							  , email: ""
							  , address: ""
							  , categories: []
							  , note: ''
							  , type: "agent"
							  , rating: ''
							  , tasks: []
						})
						opts.go(`/manager/agents/${id}`)
					}}
				/>
				<Route
					component={Agents}
					path="/manager/agents/:id"
					categoryText="Agents"
					type="agent"
					addText="New agent"
					renderEl={(opts) => (
						<AgentForm
							rightPanel = {opts.rightPanel}
							style = {opts.style}
							id = {opts.id}
							history = {opts.history}
							refTask = {opts.refTask}
							refRepMan = {opts.refRepMan}
						/>
					)}
					addFunc={(opts) => {
						let id = new Date().valueOf().toString()
						opts.docUPD({
								_id: id
							  , firstName: ""
							  , lastName: ""
							  , phoneNumber: ""
							  , cellNumber: ""
							  , email: ""
							  , address: ""
							  , categories: []
							  , note: ''
							  , type: "agent"
							  , rating: ''
							  , tasks: []
						})
						opts.go(`/manager/agents/${id}`)
					}}
				/>
			</Route>
		</Route>
		<Route path="*" component={Error404}/>
	</Route>
)



// WEBPACK FOOTER //
// ./src/routes/manager/index.js